export default __webpack_public_path__ + "static/amberlee-pix-e43b762cbc118571ed382c128c1eb359.jpg";